import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { CoverageModalComponent } from '../../coverage-modal/coverage-modal.component';
import { PolicyDetailDto, PolicyDto } from './policyDto';
import { ContactModalComponent } from './contact-modal/contact-modal.component';
import { PassangerModalComponent } from './passanger-modal/passanger-modal.component';
import { CarnetService } from '../../../services/carnet.service';
import { AuthService } from '../../../../auth/services/auth.service';
import { NgbOffcanvas, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import CarnetImageType from '../../../../../common/enums/carnetImageType';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-common-detail',
  providers: [CarnetService],
  imports: [
    CoverageModalComponent,
    NgClass,
    ContactModalComponent,
    PassangerModalComponent,
    FormsModule,
    NgbDropdownModule,
  ],
  templateUrl: './common-detail.component.html',
  styleUrl: './common-detail.component.css',
})
export class CommonDetailComponent {
  @ViewChild('coverageModal', { static: true })
  coverageModal!: CoverageModalComponent;
  @ViewChild('contactModal', { static: true })
  contactModal!: ContactModalComponent;
  @ViewChild('passangerModal', { static: true })
  passangerModal!: PassangerModalComponent;
  @ViewChild('content', { static: true }) content!: TemplateRef<any>;

  searchFilter = '';

  policyDetail: PolicyDto = {} as any;
  policySelected: PolicyDetailDto = {} as any;
  filteredPolicies: PolicyDetailDto[] = [];
  indexSelected: number = -1;
  protected readonly CarnetImageType = CarnetImageType;

  constructor(
    private carnetService: CarnetService,
    private offcanvasService: NgbOffcanvas,
    private authService: AuthService,
  ) {}

  @Input() set data(policyDetail: PolicyDto) {
    this.policyDetail = policyDetail;
    this.filteredPolicies = policyDetail.policies;
    if (policyDetail.policies && policyDetail.policies.length) {
      this.policySelected = policyDetail.policies[0];
    }
  }

  onPolicySelected(policy: any, index: number) {
    this.policySelected = policy;
    this.indexSelected = index;
    this.offcanvasService.open(this.content, {
      ariaLabelledBy: 'offcanvas-basic-title',
      position: 'end',
      beforeDismiss: () => {
        this.indexSelected = -1;
        this.policySelected = {} as any;
        return true;
      },
    });
  }

  showCoverage() {
    this.coverageModal.show(this.policySelected.coverages);
  }

  showContact() {
    this.contactModal.show(
      this.policySelected.contactInfo!,
      this.policySelected.emergencyContactInfo,
    );
  }

  showPassanger() {
    this.passangerModal.show(this.policySelected.passangers!);
  }

  downloadCarnet(type: string, vehicleNumber?: number) {
    const idNumber = this.authService.user.idTokenClaims?.extension_IdNumber;
    const reference =
      vehicleNumber !== undefined
        ? vehicleNumber
        : this.policySelected.vehicleNumber!;
    this.carnetService
      .downloadCarnet(
        this.policyDetail.policyNumber,
        idNumber!,
        type as CarnetImageType,
        reference,
      )
      .subscribe((blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download =
          type === CarnetImageType.Front
            ? 'carnet_frontal.jpg'
            : 'carnet_detras.jpg';
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  filterDetail() {
    if (!this.searchFilter) {
      this.filteredPolicies = this.policyDetail.policies;
      return;
    }

    const filter = this.searchFilter.toLowerCase().trim();

    this.filteredPolicies = this.policyDetail.policies.filter((p) => {
      const text = p.cardContent.replace(/<[^>]+>/g, '').toLowerCase(); // strip tags
      return text.includes(filter);
    });
  }
}
